module.exports = __webpack_public_path__ + "img/play.bc34c631.svg";